import React, { Component } from 'react'
import cicek1 from './images/cicek1.jpg'
import cicek2 from './images/cicek2.jpg'
import cicek3 from './images/cicek3.jpg'
import cicek4 from './images/cicek4.jpg'
import cicek5 from './images/cicek5.jpg'
import '../../home/index.css'

class Slider extends Component {

    constructor(props) {
        super(props)
        this.state = {
            images: [
                { display: "initial", cicekSrc: cicek1, opacity: 1 },
                { display: "none", cicekSrc: cicek2, opacity: 1 },
                { display: "none", cicekSrc: cicek3, opacity: 1 },
                { display: "none", cicekSrc: cicek4, opacity: 1 },
                { display: "none", cicekSrc: cicek5, opacity: 1 },
            ]
        }
        this.interval = null
    }

    componentDidMount() {
        this.changeImage()
    }

    componentWillUnmount(){
        clearInterval(this.interval)
    }

    changeImage() {
        let index = 1

        this.interval = setInterval(async () => {

            if (index >= this.state.images.length) {
                index = 0
            }

            let images = this.state.images

            if (images.length === 1 || images.length === 0) {
                return
            }

            if (index === 0) {
                images[images.length - 1].opacity = 0
                images[index].opacity = 1
                await this.setState({ images: images })

                setTimeout(async () => {
                    images[images.length - 1].display = "none"
                    images[index].display = "initial"

                    index += 1
                    await this.setState({ images: images })
                }, 300)
            } else {
                images[index].opacity = 1
                images[index - 1].opacity = 0
                await this.setState({ images: images })

                setTimeout(async () => {
                    images[index - 1].display = "none"
                    images[index].display = "initial"

                    index += 1
                    await this.setState({ images: images })

                }, 300)
            }

        }, 3300)
    }


    render() {
        return (
            <div id="slider" class="slider-container">
                {this.state.images.map(i => {
                    return (
                        <img className="slider-image" alt={"a flower"} style={{ display: i.display, opacity: i.opacity }} src={i.cicekSrc} />
                    )
                })}
            </div>
        )
    }
}

export default Slider